import { useIntl } from 'react-intl';
import { useOkapiKy } from '@folio/stripes/core';
import { useQuery } from '@tanstack/react-query';

const DEFAULT_LOCALES = [
  { value: 'ar',    label: 'العربية' },
  { value: 'en-US', label: 'English' },
];

/**
 * Fetches available locales for the tenant from /tenant-locales.
 * Falls back to DEFAULT_LOCALES if the endpoint is unavailable.
 * Returns options in {value, label} format ready for Select/dataOptions.
 */
export default function useTenantLocales() {
  const okapiKy = useOkapiKy();
  const intl    = useIntl();

  const getLocaleLabel = (localeValue) => {
    const display = intl.formatDisplayName(localeValue, { type: 'language' });
    if (display) return display;
    return localeValue;
  };

  const { data, isLoading } = useQuery({
    queryKey: ['tenant-locales'],
    queryFn: async () => {
      const res = await okapiKy.get('tenant-locales?limit=1000').json();
      return res?.locales || [];
    },
    staleTime: 10 * 60 * 1000,
    retry: false,
    onError: () => {},
  });

  const localeOptions = data?.length
    ? data.map(locale => ({
        value: locale.value,
        label: getLocaleLabel(locale.value),
      }))
    : DEFAULT_LOCALES;

  return { localeOptions, isLoading };
}
